import React from 'react';

import { EToasterStatus, showToast } from 'utils/showToast';

import { cn } from 'components/lib/utils';

export type PromotionLayout = 1 | 2 | 3;

const LAYOUT_OPTIONS: PromotionLayout[] = [1, 2, 3];

const SelectionBoxOption: React.FC<{
  layout: PromotionLayout;
  isSelected: boolean;
  onClick: (value: PromotionLayout) => void;
  testId: string;
}> = ({ layout, isSelected, onClick, testId }) => {
  return (
    <div
      className={cn(
        'flex gap-1 w-[90px] h-[38px] p-[10px] rounded-lg border border-base hover:shadow-md cursor-pointer',
        isSelected && 'border-base-black'
      )}
      onClick={() => onClick(layout)}
      data-testid={testId}
    >
      {Array.from({ length: layout }).map((_, index) => (
        <div key={index} className="w-full h-full bg-[#D9D9D9] rounded-[4px]" />
      ))}
    </div>
  );
};

export const TemplateStudioPromotionLayoutSelect: React.FC<{
  value?: PromotionLayout | null;
  onChange: (value: PromotionLayout) => void;
}> = ({ value, onChange }) => {
  const handleChange = (layout: PromotionLayout) => {
    onChange(layout);
    if (layout !== 3) return;
    showToast({
      message:
        'This layout may appear cropped in the preview. Zoom out your browser to see the full view.',
      status: EToasterStatus.INFO
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm text-black text-left mt-1 mb-2">
        {'Offers Per Row (Desktop)'}
      </div>
      <div className="group/collapsible flex justify-between items-center w-full text-base-mutedForeground text-xs leading-5 font-sans">
        {LAYOUT_OPTIONS.map((layout) => (
          <SelectionBoxOption
            key={layout}
            layout={layout}
            isSelected={value === layout}
            onClick={handleChange}
            testId={`TemplatesStudio-PromotionLayout-${layout}`}
          />
        ))}
      </div>
    </div>
  );
};
